import { api } from "@/shared/libs/axiosClient";

// 알림 대상: step1은 로테이션 primary(is_primary), step2+는 멤버 직접 지정(member_id).
// 채널은 모든 단계에서 slack + call 고정이므로 별도 필드 없음.
export interface AlertTarget {
  is_primary?: boolean;
  member_id?: number;
}

export interface EscalationStep {
  step: number;
  alert_targets: AlertTarget[];
  interval_minutes: number;
  max_attempts: number;
}

export interface AlertEscalationPolicyResponse {
  id: number;
  team_id: number;
  steps: EscalationStep[];
  call_quiet_start?: string | null;
  call_quiet_end?: string | null;
  call_resume_at?: string | null;
  created_by?: string | null;
  created_at?: string | null;
  updated_by?: string | null;
  updated_at?: string | null;
}

export interface AlertEscalationPolicyPayload {
  steps: EscalationStep[];
  call_quiet_start?: string | null;
  call_quiet_end?: string | null;
  call_resume_at?: string | null;
}

// step2+ 대상으로 선택 가능한 멤버 (스케줄 로스터 밖 팀 멤버)
export interface SelectableMember {
  member_id: number;
  name: string;
  email: string;
  picture?: string | null;
}

export async function getEscalationPolicy(
  teamId: number,
): Promise<AlertEscalationPolicyResponse> {
  return api.get<AlertEscalationPolicyResponse>(
    `/team/${teamId}/alert-escalation-policy`,
  );
}

export async function getSelectableMembers(
  teamId: number,
): Promise<SelectableMember[]> {
  return api.get<SelectableMember[]>(
    `/team/${teamId}/alert-escalation-policy/selectable-members`,
  );
}

// 팀의 현재 primary 담당자 (없으면 null)
export async function getCurrentPrimary(
  teamId: number,
): Promise<SelectableMember | null> {
  return api.get<SelectableMember | null>(
    `/team/${teamId}/alert-escalation-policy/primary-member`,
  );
}

export async function upsertEscalationPolicy(
  teamId: number,
  payload: AlertEscalationPolicyPayload,
): Promise<AlertEscalationPolicyResponse> {
  return api.put<AlertEscalationPolicyResponse>(
    `/team/${teamId}/alert-escalation-policy`,
    payload,
  );
}

export async function createEscalationPolicy(
  teamId: number,
  payload: AlertEscalationPolicyPayload,
): Promise<AlertEscalationPolicyResponse> {
  return api.post<AlertEscalationPolicyResponse>(
    `/team/${teamId}/alert-escalation-policy`,
    payload,
  );
}
